<template>
  <div>
    <h5>Artikel:</h5>
    <b-list-group>
      <ArticleListEntry
        v-for="article in articles"
        :key="article.id"
      />
      <b-list-group-item
        :to="{ path: `/Artikel`}"
        class="flex-column align-items-start"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1 text-primary">
            Mehr Artikel
          </h5>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import ArticleListEntry from './ArticleListEntry'
import { mapGetters } from 'vuex'

export default {
  name: 'ArticleShortList',
  components: { ArticleListEntry },
  props: {
    amount: {
      type: Number,
      default: 5,
      max: 15,
      min: 1
    }
  },
  computed: {
    ...mapGetters([
      'getLatestArticles'
    ]),
    articles () {
      return this.getLatestArticles(this.$props.amount)
    }
  },
  mounted () {
    this.$store.dispatch('getArticles', 1)
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.list-group-item:last-child {
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
}
</style>
